import styles from "./BurgerModal.module.css";
import { useModal } from "../../hooks/useModalHook";
import { ReactComponent as CloseBurgerIcon } from "../../images/svg/close_burger.svg";
import { ReactComponent as MetroIcon } from "../../images/svg/metro.svg";
import { Link as ScrollLink } from "react-scroll";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import { useAbVariant } from "../../hooks/useAbVariant";

const navItems = [
  { href: "#main", text: "Главная", section: "main" },
  { href: "#doctors", text: "Врачи", section: "doctors" },
  { href: "#reviews", text: "Отзывы", section: "reviews" },
  { href: "#licenses", text: "Лицензии", section: "licenses" },
  { href: "#faq", text: "Вопросы", section: "faq" },
  { href: "#gallery", text: "Дети", section: "gallery" },
];

// В варианте C на странице только эти секции — остальные пункты меню убираем.
const VARIANT_C_SECTIONS = ["main", "doctors", "reviews"];

const scrollToSection = (section, closeModal) => (e) => {
  e.preventDefault();
  closeModal();
  if (section) {
    const el = document.getElementById(section);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

};

const BurgerModal = () => {
  const { closeModal, openModal } = useModal();

  const location = useLocation();
  const isRoot = ["/", "/b", "/c"].includes(location.pathname);
  const variant = useAbVariant();
  const visibleNavItems =
    variant === "c"
      ? navItems.filter((i) => VARIANT_C_SECTIONS.includes(i.section))
      : navItems;

  const closeMenuAndOpenModal = () => {
    closeModal();
    openModal("appointment");
  };

  useEffect(() => {
  }, [location.pathname]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Меню"
      className={styles.burger_modal}
    >
      <button
        onClick={closeModal}
        aria-label="Закрыть меню"
        className={styles.close_button}
      >
        <CloseBurgerIcon aria-label="Закрыть меню" />
      </button>
      {/* <div className={`${styles.header_left_menu} ${styles.active}`}> 
        <Link to="/" aria-label="На главную">
          <picture>
            <source media="(max-width: 1024px)" srcSet={logoMobile} />
            <source media="(min-width: 769px)" srcSet={logo} />
            <img
              className={styles.logo}
              src={logo}
              alt="Логотип AltraVita"
              decoding="async"
              loading="lazy"
            />
          </picture>
        </Link>
      </div> */}

      <nav aria-label="Основная навигация">
        <ul className={`${styles.nav_menu} ${styles.active} ${styles.nav_menu_burger}`}>
          {!isRoot ? (
            <li className={styles.nav_menu_item}>
              <Link to="/" className={styles.nav_menu_link} onClick={closeModal}>
                Вернуться на главную
              </Link>
            </li>
          ) : (
            <>
              {visibleNavItems.map((item, index) => {
                if (item.section === "gallery") return;
                return (
                  <li className={styles.nav_menu_item} key={index}>
                    {item.section ? (
                      <ScrollLink
                        to={item.section}
                        smooth={true}
                        offset={-80}
                        duration={500}
                        className={styles.nav_menu_link}
                        activeClass={styles.active}
                        spy={true}
                        tabIndex={0}
                        onClick={closeModal}
                      >
                        {item.text}
                      </ScrollLink>
                    ) : (
                      <a
                        href={item.href}
                        className={`${styles.nav_menu_link} ${styles.active}`}
                        onClick={scrollToSection(item.section, closeModal)}
                        tabIndex={0}
                      >
                        {item.text}
                      </a>
                    )}
                  </li>
                )
              })}
            </>
          )}
        </ul>
      </nav>

      <button
        className={styles.appointment_burger + " light_sweep"}
        onClick={closeMenuAndOpenModal}
        aria-label="Записаться"
      >
        <span>Записаться</span>
      </button>

      {/* Контакты и адрес внизу модального окна */}
      <div className={styles.burger_contacts}>
        <div className={styles.burger_contacts_left}>
          <p className={styles.burger_contacts_label}>Работаем:</p>
          <ul>
            <li className={styles.burger_contacts_work_day}>пн-сб: 8:00-20:00</li>
            <li className={styles.burger_contacts_work_day}>вс: 8:00-18:00</li>
          </ul>

          <a href="tel:+74992260316" className={styles.burger_contacts_phone}>+7 499 226 03 16</a>
        </div>
        <address className={styles.burger_contacts_right}>
          <div className={styles.metro_row}>
            <span className={styles.metro_icon}><MetroIcon aria-label="Метро Нагорная" /></span>
            <span className={styles.metro_name}>Нагорная</span>
          </div>
          <div className={styles.burger_contacts_address}>г. Москва,<br />ул.Нагорная 4а</div>
        </address>
      </div>
    </div>
  );
};

export default BurgerModal; 